<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div id="background" style="height: 100%;
    width: 100vw;
    position:fixed;
    background: url(/static/images/bolang/bg.png) no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;">
      <img src="/static/images/bolang/logo.png" alt=""
        style="width: 30%;height: auto;position: absolute;top: 6%;right: 35%;">
      <img src="/static/images/bolang/dymic.gif" alt=""
        style="width: 90%;height: auto;position: absolute;top: 10%;right: 5%;">
        
      <div v-if="antiresultShow"
        style="width: 100%;position: absolute;top:57%;text-align: center;align-items: center;display: flex;flex-direction: column;">
        <span style="font-size: 14px;font-weight:500;">编码:{{ this.antiCode }}</span>
        <div style="width: 57%;margin-top: 25px;font-size: 14px;font-weight:500;"><span v-html="antiresult"></span>
        </div>
      </div>

      <div
        style="width: 100%;position: absolute;bottom: 5%;top:75%;text-align: center;display: flex;justify-content: center;">
        <div style="width: 89%; background: url(/static/images/bolang/bg2.png) no-repeat;
    background-size: cover;;display: flex;justify-content: center;border-radius: 10px;opacity: 1;">
          <div style="width: 62%;display: flex;justify-content: center;align-items: center;flex-direction: column;">
            <img src="/static/images/bolang/scan_qr_tip.png" style="width: 75%;margin-left: -15px;"></img>
            <img src="/static/images/bolang/hengxian.png" style="width: 78%;margin-top:5px;margin-left: -10px;"></img>
            <img src="/static/images/bolang/add_wecom.png" style="width: 76%;margin-top:5px;margin-left: -15px;"></img>
          </div>
          <div style="width: 38%;display: flex;justify-content: center;flex-direction: column;">
            <img style="width: 100px;aspect-ratio: 1 / 1;" src="/static/images/bolang/wecom.png"></img>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      antiresultShow: false,
      antiresult: "",
      antiCode: ""
    }
  },
  methods: {
    getResult() {
      const params = this.$route.query;
      const code = params.c;
      getAntiResult(code).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.antiresultShow = false;
          alert("防伪查询失败,请联系管理员");
        } else {
          this.antiCode = data.data.code
          this.antiresult = data.message
          this.antiresultShow = true;
        }
      }).catch(err =>
        alert("查询异常，请联系管理员")
      )

    }
  },
  created: function () {
    this.getResult()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/BoLangFeiLin/Index.vue